import { render, staticRenderFns } from "./InsurersUpdate.vue?vue&type=template&id=fc5c6002"
import script from "./InsurersUpdate.vue?vue&type=script&lang=js"
export * from "./InsurersUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports